import { useCallback } from "react";
import useAxios from '@Apis/useAxios';
import {
    GET_MEMBER_DEVICE_ORDER_INFO_API,
    GET_EMPLOYEE_DEVICE_ORDER_INFO_API
} from '@Apis/apiPath';

const useDeviceOrderApi = () => {
    const Axios = useAxios();

    const getMemberDeviceOrderApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_DEVICE_ORDER_INFO_API);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getEmployeeDeviceOrderApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_EMPLOYEE_DEVICE_ORDER_INFO_API);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    
    return {
        getMemberDeviceOrderApi,
        getEmployeeDeviceOrderApi
    };
};

export default useDeviceOrderApi;